import publicAxiosInstance from "./publicAxiosInstance";

export const loginApi = async (payload: FormData) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response: any = await publicAxiosInstance.post(`/login/`, payload);
  return response?.data;
};
